import { render, staticRenderFns } from "./PageDocProductionsAide.vue?vue&type=template&id=130a56b4&"
import script from "./PageDocProductionsAide.vue?vue&type=script&lang=js&"
export * from "./PageDocProductionsAide.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('130a56b4')) {
      api.createRecord('130a56b4', component.options)
    } else {
      api.reload('130a56b4', component.options)
    }
    module.hot.accept("./PageDocProductionsAide.vue?vue&type=template&id=130a56b4&", function () {
      api.rerender('130a56b4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/Production/PageDocProductionsAide.vue"
export default component.exports